// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// RxJS
import { Observable, BehaviorSubject } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// Models
import { OrderModel } from '../_models/order.model';
import { environment } from '../../../../environments/environment';
const API_Order_URL = environment.API_URL
// Real REST API
@Injectable()
export class OrderService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));

	constructor(private http: HttpClient,
		           private httpUtils: HttpUtilsService) { }

	// CREATE =>  POST: add a new Order to the server
	createOrder(Order): Observable<OrderModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<OrderModel>(API_Order_URL, Order, { headers: httpHeaders });
	}

	// READ
	getAllOrder(): Observable<OrderModel[]> {
		return this.http.get<OrderModel[]>(API_Order_URL);
	}

	getOrderById(OrderId: number): Observable<OrderModel> {
		//return this.http.get<OrderModel>(API_Order_URL + `/${OrderId}`);

		const userToken = localStorage.getItem('userdata');
		const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json',
              Authorization: 'Basic ' + btoa('ecao:GhSJp[6!2npr95p'),
              'accessToken': userToken
            })
          };
		const httpParams = {"userId": `${OrderId}`}

		const url = API_Order_URL + 'user/get';
		return this.http.post<OrderModel>(url , httpParams , httpOptions)
	}

	// Server should return filtered/sorted result
	findOrder(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const userToken = localStorage.getItem('userdata');
		const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json',
              Authorization: 'Basic ' + btoa('ecao:GhSJp[6!2npr95p'),
              'accessToken': userToken
            })
		  };
		const httpParams = queryParams

		const url = API_Order_URL + 'categories/admin/list';
		return this.http.post<QueryResultsModel>(url , httpParams , httpOptions)
	}

	// UPDATE => PUT: update the Order on the server
	updateOrder(Order: OrderModel): Observable<any> {
		// Note: Add headers if needed (tokens/bearer)
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.put(API_Order_URL, Order, { headers: httpHeaders });
	}

	// UPDATE Status
	// Comment this when you start work with real server
	// This code imitates server calls
	updateStatusForOrder(Order: string, status: boolean): Observable<any> {
		const userToken = localStorage.getItem('userdata');
		const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json',
              Authorization: 'Basic ' + btoa('ecao:GhSJp[6!2npr95p'),
              'accessToken': userToken
            })
          };
		const body = {
			userId: Order,
			isBlock: status
		};
		const url = API_Order_URL + 'user/admin/blockUnBlock';
		return this.http.post(url, body, httpOptions);
	}

	// DELETE => delete the Order from the server
	deleteOrder(catId: string): Observable<OrderModel> {

		const userToken = localStorage.getItem('userdata');
		const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json',
              Authorization: 'Basic ' + btoa('ecao:GhSJp[6!2npr95p'),
              'accessToken': userToken
            })
          };
		const body = {
			id: catId,
		};
		const url = `${API_Order_URL}`+'categories/admin/delete';
		return this.http.post<OrderModel>(url , body , httpOptions);
	}

	deleteOrders(ids: number[] = []): Observable<any> {
		const url = API_Order_URL + '/delete';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const body = { prdocutIdsForDelete: ids };
		return this.http.put<QueryResultsModel>(url, body, { headers: httpHeaders} );
	}
}
